// src/components/BlogList.js
import React, { useEffect, useState } from 'react';
import axios from 'axios';

const BlogList = ({ onBlogDeleted, onEditBlog }) => {
  const [blogs, setBlogs] = useState([]);
  const [alert, setAlert] = useState({ message: '', type: '' });

  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        const response = await axios.get('https://sribala.hxbindia.com/blogs');
        setBlogs(response.data);
      } catch (error) {
        console.error('Error fetching blogs:', error);
      }
    };

    fetchBlogs();
  }, []);

  const handleDelete = async (id) => {
    try {
      await axios.delete(`https://sribala.hxbindia.com/blogs/${id}`);
      setBlogs(blogs.filter((blog) => blog._id !== id));
      onBlogDeleted();
      setAlert({ message: 'Blog deleted successfully!', type: 'success' });
      setTimeout(() => setAlert({ message: '', type: '' }), 3000);
    } catch (error) {
      console.error('Error deleting blog:', error);
      setAlert({ message: 'Error deleting blog.', type: 'danger' });
      setTimeout(() => setAlert({ message: '', type: '' }), 3000);
    }
  };

  return (

    <div className="container d-flex justify-content-center ">
<div className="col-md-9 pt-5">
    <div>


      <h2>Blogs</h2>
      {alert.message && (
        <div className={`alert alert-${alert.type} mt-3`} role="alert">
          {alert.message}
        </div>
      )}
      <div className="row">
        {blogs.map((blog) => (
          <div key={blog._id} className="col-md-4 mb-4">
            <div className="card h-100">
              <img src={`https://sribala.hxbindia.com/${blog.image}`} alt={blog.heading} className="card-img-top" />
              <div className="card-body">
                <h5 className="card-title">{blog.heading}</h5>
                <p className="card-text">
                  {blog.paragraphs.join(' ').split('|').map((line, index) => (
                    <React.Fragment key={index}>
                      {line.trim()}<br />
                    </React.Fragment>
                  ))}
                </p>
              </div>
              <div className="card-footer d-flex justify-content-between">
                <button className="btn btn-warning btn-sm" onClick={() => onEditBlog(blog)}>Edit</button>
                <button className="btn btn-danger btn-sm" onClick={() => handleDelete(blog._id)}>Delete</button>
              </div>
            </div>
          </div>
        ))}
      </div>
      </div>
    </div>
    </div>
  );
};

export default BlogList;
